import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		content: {
			display: 'flex',
			alignItems: 'center',
		},
		text: {
			padding: theme.spacing(0, 2, 0, 1),

			[theme.breakpoints.down('sm')]: {
				padding: theme.spacing(1, 2, 1, 1),
			},
		},
		image: {
			maxWidth: theme.spacing(3.25),
			'& picture': {
				display: 'flex',
				justifyContent: 'center',
			},
			'& img': {
				objectPosition: 'center',
				objectFit: 'contain',
			},
		},
	}),
	{ name: 'CallToAction-Cta16_17' },
)

export default useStyles
